// DUPLICATE!
export const getMeasureByType = (measureObject, type) => {
  switch (type) {
    case 'temperature':
      return measureObject.degree;

    case 'position':
      return measureObject.point
        ? `lat: ${measureObject.point.lat}, lon: ${measureObject.point.lon}`
        : undefined;

    case 'movement':
      return measureObject.moving;

    default:
      break;
  }
};
